import ReactSwiper from './ReactSwiper';

export default ReactSwiper;



// WEBPACK FOOTER //
// ./js/index.js